import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./styles/console.scss";
import { AuthProvider } from "./auth/AuthContext";
import AuthModal from "./auth/AuthModal";
import ConsoleLayout from "./layout/ConsoleLayout";
import Dashboard from "./pages/Dashboard";
import OriginalOrders from "./pages/OriginalOrders";
import ThirdPartyOrders from "./pages/ThirdPartyOrders";
import Billing from "./pages/Billing";
import UsageStats from "./pages/UsageStats";
import PlanManagement from "./pages/PlanManagement";
import ApiKeys from "./pages/ApiKeys";
import AccountSettings from "./pages/AccountSettings";
import Terms from "./pages/legal/Terms";
import Privacy from "./pages/legal/Privacy";
import Pricing from "./pages/Pricing";

/**
 * CloudStore API 控制台（hash 路由）
 *
 * URL 形式：
 *   域名/cloudstore-api            → 默认 Pricing（营销页）
 *   域名/cloudstore-api/#/dashboard → 控制台各页（需登录）
 *
 * 路由分三类：
 *   - 公开页：默认(Pricing)、/pricing、/terms、/privacy
 *   - 重置密码：/reset-password（邮件链接落地，hash 里携带 token/email）
 *   - 控制台：由 ConsoleLayout 按登录态渲染，未登录时在 body 区弹登录框（仅露出顶部导航栏）
 */
const CloudstoreApiApp = () => {
  return (
    <AuthProvider>
      <Toaster position="top-center" />
      <Routes>
        {/* 默认页 & 公开页 */}
        <Route index element={<Pricing />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />

        {/* 重置密码落地页：直接进入重置视图 */}
        <Route
          path="reset-password"
          element={<AuthModal initialView="reset" />}
        />

        {/* 控制台：外壳(header+sidebar)始终渲染；ConsoleLayout 内部按登录态
            决定渲染页面内容还是登录弹窗（未登录时遮罩覆盖 body，仅露出顶部导航栏） */}
        <Route element={<ConsoleLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="original-orders" element={<OriginalOrders />} />
          <Route path="third-party-orders" element={<ThirdPartyOrders />} />
          <Route path="billing" element={<Billing />} />
          <Route path="usage-stats" element={<UsageStats />} />
          <Route path="plan-management" element={<PlanManagement />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route path="account-settings" element={<AccountSettings />} />
        </Route>

        {/* 未知路径回默认 Pricing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default CloudstoreApiApp;
